import React, { useMemo } from "react";
import PortfolioGallery from "./PortfolioGallery";
import { ProfileData } from "@/hooks/useProfiles";
import EmptyStatePublic from "./EmptyStatePublic";

interface PortfolioTabProps {
  profile?: ProfileData | null;
  hideTitle?: boolean;
  openPortfolioModal?: any;
  onClosePortfolioModal?: () => void;
}

const PortfolioTab = ({ profile, hideTitle = false, openPortfolioModal, onClosePortfolioModal }: PortfolioTabProps) => {
  const portfolioItems = useMemo(
    () =>
      (profile?.portfolio_items || []).filter(
        (item) => item.status !== "draft"
      ),
    [profile?.portfolio_items]
  );

  return (
    <div className="space-y-6">
      {/* Portfolio content */}
      {portfolioItems && portfolioItems.length > 0 ? (
        <PortfolioGallery
          username={profile?.username || "Designer"}
          username_slug={profile?.username_slug || ""}
          portfolioItems={portfolioItems}
          profile={profile as { 
            id: string;
            avatar_url?: string | null;
            profession?: string | null;
            display_name?: string | null;
          }}
          openPortfolioModal={openPortfolioModal}
          onClosePortfolioModal={onClosePortfolioModal}
        />
      ) : (
        <EmptyStatePublic
          type="portfolio"
          username={profile?.username}
          profileId={profile?.id}
          profile={profile as any}
        />
      )}
    </div>
  );
};

export default PortfolioTab;
